module.exports = __webpack_public_path__ + "static/img/drip-logo.453d655c.svg";